import { CursoModel } from './CursoModel'
import { TurmaModel } from './TurmaModel'
import { UsuarioModel } from './UsuarioModel'
import { PagamentoModel } from './PagamentoModel'
import { ParceiroModel } from './ParceiroModel'

export class MatriculaModel {
  id: number
  createdAt: string
  matricula: string
  cobranca: any
  pixDiscountPercentage?: number
  uf: string
  ufMatriculaDetran?: string
  statusDetran: STATUS_MATRICULA
  cpfInstrutor: string
  dataInicioCurso: Date
  dataFimCurso: Date
  dataInicioModuloTeorico: Date
  dataFimModuloTeorico: Date
  dataInicioModuloPratico: string
  dataFimModuloPratico: string
  dataValidadeCurso: Date
  identificacaoCertificado: string
  identificacaoCertificadoRetornado: string
  identificacaoCertificadoRetornadoTeorico: string
  nota: string
  dataValidacaoFacialInicial: Date
  dataValidacaoFacialFinal: Date
  alunoId: number
  aluno: UsuarioModel
  renach: string

  cursoId: number
  curso: CursoModel

  pagamentoId?: number
  pagamento?: PagamentoModel

  turmaId: number

  permiteEmissaoCertificado?: boolean
  dataEmissaoCertificado?: Date

  parceiroCursoPraticoId?: number
  parceiroId?: number
  parceiro?: ParceiroModel

  turma: TurmaModel

  estatisticasEstudos?: Array<{
    id: number
    moduloId: number
    percentualProgressoMaisAvancado: number
    moduloCompleto?: boolean
    modulo?: {
      id: number
      nome: string
      ordenacao: number
    }
  }>

  dataMatriculaDetran?: Date
}

class Pagador {
  cpfCnpj: string
  nome: string
}

class BeneficiarioFinal {
  cpfCnpj: string
  nome: string
}

class Split {
  cpfCnpj: string
  nome: string
  valor: number
}

enum MEIO_PAGAMENTO {
  CARTAO_CREDITO = 'CARTAO_CREDITO',
  PIX = 'PIX',
  BOLETO = 'BOLETO',
}

export enum STATUS_MATRICULA {
  AGUARDANDO_MATRICULA = 'AGUARDANDO_MATRICULA',
  MATRICULADO = 'MATRICULADO',
  FINALIZADO = 'FINALIZADO',
  AGUARDANDO_ENVIO = 'AGUARDANDO_ENVIO',
  AGUARDANDO_MATRICULA_MODULO_PRATICO = 'AGUARDANDO_MATRICULA_MODULO_PRATICO',
  AGUARDANDO_CONCLUSAO_MODULO_PRATICO = 'AGUARDANDO_CONCLUSAO_MODULO_PRATICO',
}
